module.exports = __webpack_public_path__ + "img/paul_h.7668cc56.png";